export enum PaymentServices {
    OD_PAY = 'od_pay',
    VK_PAY = 'vk_pay',
    MM_PAY = 'mm_pay',
    FC_PAY = 'fc_pay',
    FB_PAY = 'fb_pay',
    GOOGLE_PAY = 'google_pay',
    IOS_PAY = 'ios_pay',
    ADYEN = 'adyen',
    STEAM = 'steam',
    XSOLLA = 'xsolla'
}
